
import { useState, useEffect } from 'react';
import type { PEOProvider } from '@/types/peo.types';

/**
 * Hook to manage the state of PEO providers
 */
export const useProvidersState = (fetchedProviders: PEOProvider[] = []) => {
  const [localProviders, setLocalProviders] = useState<PEOProvider[]>([]);
  const [isDeletingProvider, setIsDeletingProvider] = useState(false);
  
  // Update local providers state when API data changes
  useEffect(() => {
    if (fetchedProviders.length > 0) {
      console.log('Updating local providers state with fetched data:', fetchedProviders.length);
      setLocalProviders(fetchedProviders);
    }
  }, [fetchedProviders]);

  return {
    localProviders,
    setLocalProviders,
    isDeletingProvider,
    setIsDeletingProvider
  };
};
